(function () {
  'use strict';

  class CustomProductPage {
    constructor(section) {
      this.section = section;
      this.sectionId = section.dataset.sectionId || '';

      /* Gallery elements */
      this.gallery = section.querySelector('[data-product-gallery]');

      this.galleryThumbnails = [];
      this.galleryMediaItems = [];
      this.galleryDots = [];

      this.galleryPreviousButton = null;
      this.galleryNextButton = null;

      this.activeMediaId = null;
      this.activeMediaIndex = 0;

      /* Mobile swipe */
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minimumSwipeDistance = 40;

      /* Future modules */
      this.info = section.querySelector('[data-product-info]');
      this.relatedSlider = section.querySelector(
        '[data-related-slider]'
      );

      this.init();
    }

    init() {
      this.initGallery();

      /*
       * STEP 6 PART 2:
       * Zoom modal methods yahan initialize honge.
       */
      this.initGalleryModal();

      /*
       * STEP 6 PART 3:
       * Variant selector methods yahan initialize honge.
       */
       this.initVariants();

      /*
       * STEP 6 PART 4:
       * Add to Cart aur Buy Now yahan initialize honge.
       */

      this.initProductForm();

      /*
       * STEP 6 PART 5:
       * Quantity, wishlist aur tabs yahan initialize honge.
       */

      this.initQuantity();
      this.initWishlist();
      this.initProductTabs();

      /*
       * STEP 6 PART 6:
       * Related slider aur final initialization yahan hoga.
       */

      this.initRelatedProducts();
      this.initStickyProductInfo();
      this.initThemeEditorEvents();
    }

    /* =========================================================
       GALLERY INITIALIZATION
       ========================================================= */

    initGallery() {
      if (!this.gallery) {
        return;
      }

      this.galleryThumbnails = Array.from(
        this.gallery.querySelectorAll('[data-gallery-thumbnail]')
      );

      this.galleryMediaItems = Array.from(
        this.gallery.querySelectorAll('[data-gallery-media]')
      );

      this.galleryDots = Array.from(
        this.gallery.querySelectorAll('[data-gallery-dot]')
      );

      this.galleryPreviousButton = this.gallery.querySelector(
        '[data-gallery-previous]'
      );

      this.galleryNextButton = this.gallery.querySelector(
        '[data-gallery-next]'
      );

      if (this.galleryMediaItems.length === 0) {
        return;
      }

      this.setInitialGalleryMedia();
      this.bindGalleryThumbnails();
      this.bindGalleryDots();
      this.bindGalleryNavigation();
      this.bindGalleryKeyboard();
      this.bindGallerySwipe();
      this.updateGalleryNavigationState();
    }

    setInitialGalleryMedia() {
      let activeMedia = this.galleryMediaItems.find((item) =>
        item.classList.contains('is-active')
      );

      if (!activeMedia) {
        activeMedia = this.galleryMediaItems[0];
      }

      this.activeMediaId = String(activeMedia.dataset.mediaId || '');

      const activeIndex = this.galleryMediaItems.findIndex(
        (item) =>
          String(item.dataset.mediaId) === this.activeMediaId
      );

      this.activeMediaIndex = activeIndex >= 0 ? activeIndex : 0;

      this.showGalleryMedia(this.activeMediaId, {
        updateVariant: false,
        focusThumbnail: false
      });
    }

    /* =========================================================
       THUMBNAILS
       ========================================================= */

    bindGalleryThumbnails() {
      this.galleryThumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const mediaId = String(
            thumbnail.dataset.mediaId || ''
          );

          if (!mediaId) {
            return;
          }

          this.showGalleryMedia(mediaId, {
            focusThumbnail: false
          });
        });
      });
    }

    bindGalleryDots() {
      this.galleryDots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const mediaId = String(dot.dataset.mediaId || '');

          if (!mediaId) {
            return;
          }

          this.showGalleryMedia(mediaId, {
            focusThumbnail: true
          });
        });
      });
    }

    /* =========================================================
       PREVIOUS / NEXT
       ========================================================= */

    bindGalleryNavigation() {
      if (this.galleryPreviousButton) {
        this.galleryPreviousButton.addEventListener(
          'click',
          () => {
            this.showPreviousGalleryMedia();
          }
        );
      }

      if (this.galleryNextButton) {
        this.galleryNextButton.addEventListener(
          'click',
          () => {
            this.showNextGalleryMedia();
          }
        );
      }
    }

    showPreviousGalleryMedia() {
      if (this.galleryMediaItems.length <= 1) {
        return;
      }

      let nextIndex = this.activeMediaIndex - 1;

      if (nextIndex < 0) {
        nextIndex = this.galleryMediaItems.length - 1;
      }

      const mediaItem = this.galleryMediaItems[nextIndex];

      if (!mediaItem) {
        return;
      }

      this.showGalleryMedia(
        String(mediaItem.dataset.mediaId || ''),
        {
          focusThumbnail: true
        }
      );
    }

    showNextGalleryMedia() {
      if (this.galleryMediaItems.length <= 1) {
        return;
      }

      let nextIndex = this.activeMediaIndex + 1;

      if (nextIndex >= this.galleryMediaItems.length) {
        nextIndex = 0;
      }

      const mediaItem = this.galleryMediaItems[nextIndex];

      if (!mediaItem) {
        return;
      }

      this.showGalleryMedia(
        String(mediaItem.dataset.mediaId || ''),
        {
          focusThumbnail: true
        }
      );
    }

    /* =========================================================
       SHOW SELECTED MEDIA
       ========================================================= */

    showGalleryMedia(mediaId, options = {}) {
      if (!mediaId) {
        return;
      }

      const settings = {
        focusThumbnail: false,
        updateVariant: true,
        ...options
      };

      const selectedMedia = this.galleryMediaItems.find(
        (item) =>
          String(item.dataset.mediaId || '') === String(mediaId)
      );

      if (!selectedMedia) {
        return;
      }

      this.pauseInactiveGalleryMedia(selectedMedia);

      this.galleryMediaItems.forEach((item) => {
        const isSelected =
          String(item.dataset.mediaId || '') === String(mediaId);

        item.classList.toggle('is-active', isSelected);
        item.hidden = !isSelected;

        item.setAttribute(
          'aria-hidden',
          isSelected ? 'false' : 'true'
        );
      });

      this.galleryThumbnails.forEach((thumbnail) => {
        const isSelected =
          String(thumbnail.dataset.mediaId || '') ===
          String(mediaId);

        thumbnail.classList.toggle('is-active', isSelected);

        thumbnail.setAttribute(
          'aria-current',
          isSelected ? 'true' : 'false'
        );

        if (isSelected && settings.focusThumbnail) {
          this.scrollThumbnailIntoView(thumbnail);
        }
      });

      this.galleryDots.forEach((dot) => {
        const isSelected =
          String(dot.dataset.mediaId || '') === String(mediaId);

        dot.classList.toggle('is-active', isSelected);

        dot.setAttribute(
          'aria-current',
          isSelected ? 'true' : 'false'
        );
      });

      this.activeMediaId = String(mediaId);

      const selectedIndex = this.galleryMediaItems.findIndex(
        (item) =>
          String(item.dataset.mediaId || '') === String(mediaId)
      );

      if (selectedIndex >= 0) {
        this.activeMediaIndex = selectedIndex;
      }

      this.playActiveGalleryMedia(selectedMedia);
      this.updateGalleryNavigationState();

      this.section.dispatchEvent(
        new CustomEvent('custom-product:media-change', {
          bubbles: true,
          detail: {
            mediaId: this.activeMediaId,
            mediaIndex: this.activeMediaIndex,
            updateVariant: settings.updateVariant
          }
        })
      );
    }

    scrollThumbnailIntoView(thumbnail) {
      if (!thumbnail) {
        return;
      }

      try {
        thumbnail.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      } catch (error) {
        thumbnail.scrollIntoView();
      }
    }

    /* =========================================================
       VIDEO AND MODEL CONTROL
       ========================================================= */

    pauseInactiveGalleryMedia(activeMedia) {
      this.galleryMediaItems.forEach((item) => {
        if (item === activeMedia) {
          return;
        }

        const videos = item.querySelectorAll('video');

        videos.forEach((video) => {
          try {
            video.pause();
          } catch (error) {
            // Browser may block media control.
          }
        });

        const externalVideos = item.querySelectorAll(
          'iframe[src*="youtube"], iframe[src*="vimeo"]'
        );

        externalVideos.forEach((iframe) => {
          this.pauseExternalVideo(iframe);
        });

        const modelViewer = item.querySelector('model-viewer');

        if (
          modelViewer &&
          typeof modelViewer.pause === 'function'
        ) {
          try {
            modelViewer.pause();
          } catch (error) {
            // Model viewer control may not be available.
          }
        }
      });
    }

    playActiveGalleryMedia(activeMedia) {
      if (!activeMedia) {
        return;
      }

      const video = activeMedia.querySelector('video');

      if (video && video.hasAttribute('autoplay')) {
        const playPromise = video.play();

        if (
          playPromise &&
          typeof playPromise.catch === 'function'
        ) {
          playPromise.catch(() => {
            // Autoplay may be blocked by the browser.
          });
        }
      }
    }

    pauseExternalVideo(iframe) {
      if (!iframe || !iframe.contentWindow) {
        return;
      }

      try {
        iframe.contentWindow.postMessage(
          JSON.stringify({
            event: 'command',
            func: 'pauseVideo',
            args: []
          }),
          '*'
        );

        iframe.contentWindow.postMessage(
          JSON.stringify({
            method: 'pause'
          }),
          '*'
        );
      } catch (error) {
        // Cross-origin player may reject the command.
      }
    }

    /* =========================================================
       KEYBOARD NAVIGATION
       ========================================================= */

    bindGalleryKeyboard() {
      if (!this.gallery) {
        return;
      }

      this.gallery.addEventListener('keydown', (event) => {
        const target = event.target;

        const isGalleryControl =
          target.closest('[data-gallery-thumbnail]') ||
          target.closest('[data-gallery-media]') ||
          target.closest('[data-gallery-previous]') ||
          target.closest('[data-gallery-next]');

        if (!isGalleryControl) {
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showPreviousGalleryMedia();
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showNextGalleryMedia();
        }

        if (event.key === 'Home') {
          event.preventDefault();

          const firstMedia = this.galleryMediaItems[0];

          if (firstMedia) {
            this.showGalleryMedia(
              String(firstMedia.dataset.mediaId || ''),
              {
                focusThumbnail: true
              }
            );
          }
        }

        if (event.key === 'End') {
          event.preventDefault();

          const lastMedia =
            this.galleryMediaItems[
              this.galleryMediaItems.length - 1
            ];

          if (lastMedia) {
            this.showGalleryMedia(
              String(lastMedia.dataset.mediaId || ''),
              {
                focusThumbnail: true
              }
            );
          }
        }
      });
    }

    /* =========================================================
       MOBILE SWIPE
       ========================================================= */

    bindGallerySwipe() {
      const mainGallery = this.gallery.querySelector(
        '.custom-product-gallery__main'
      );

      if (!mainGallery) {
        return;
      }

      mainGallery.addEventListener(
        'touchstart',
        (event) => {
          if (!event.changedTouches[0]) {
            return;
          }

          this.touchStartX =
            event.changedTouches[0].screenX;

          this.touchStartY =
            event.changedTouches[0].screenY;
        },
        {
          passive: true
        }
      );

      mainGallery.addEventListener(
        'touchend',
        (event) => {
          if (!event.changedTouches[0]) {
            return;
          }

          this.touchEndX =
            event.changedTouches[0].screenX;

          this.touchEndY =
            event.changedTouches[0].screenY;

          this.handleGallerySwipe();
        },
        {
          passive: true
        }
      );
    }

    handleGallerySwipe() {
      const horizontalDistance =
        this.touchStartX - this.touchEndX;

      const verticalDistance =
        this.touchStartY - this.touchEndY;

      if (
        Math.abs(horizontalDistance) <
        this.minimumSwipeDistance
      ) {
        return;
      }

      if (
        Math.abs(verticalDistance) >
        Math.abs(horizontalDistance)
      ) {
        return;
      }

      if (horizontalDistance > 0) {
        this.showNextGalleryMedia();
      } else {
        this.showPreviousGalleryMedia();
      }
    }

    /* =========================================================
       NAVIGATION STATE
       ========================================================= */

    updateGalleryNavigationState() {
      const hasMultipleMedia =
        this.galleryMediaItems.length > 1;

      if (this.galleryPreviousButton) {
        this.galleryPreviousButton.disabled =
          !hasMultipleMedia;

        this.galleryPreviousButton.setAttribute(
          'aria-disabled',
          hasMultipleMedia ? 'false' : 'true'
        );
      }

      if (this.galleryNextButton) {
        this.galleryNextButton.disabled =
          !hasMultipleMedia;

        this.galleryNextButton.setAttribute(
          'aria-disabled',
          hasMultipleMedia ? 'false' : 'true'
        );
      }
    }

    /* =========================================================
       VARIANT MEDIA HOOK
       This method Part 3 me variant selector use karega.
       ========================================================= */

    showVariantMedia(featuredMediaId) {
      if (!featuredMediaId) {
        return;
      }

      const mediaExists = this.galleryMediaItems.some(
        (item) =>
          String(item.dataset.mediaId || '') ===
          String(featuredMediaId)
      );

      if (!mediaExists) {
        return;
      }

      this.showGalleryMedia(String(featuredMediaId), {
        focusThumbnail: true,
        updateVariant: false
      });
    }

    /* =========================================================
       FUTURE PART 2 METHODS — ZOOM MODAL
       ========================================================= */

   initGalleryModal() {
  if (!this.gallery) {
    return;
  }

  this.galleryModal = this.gallery.querySelector(
    '[data-gallery-modal]'
  );

  if (!this.galleryModal) {
    return;
  }

  this.galleryZoomTriggers = Array.from(
    this.gallery.querySelectorAll('[data-gallery-zoom]')
  );

  this.galleryModalItems = Array.from(
    this.galleryModal.querySelectorAll(
      '[data-gallery-modal-item]'
    )
  );

  this.galleryModalCloseButtons = Array.from(
    this.galleryModal.querySelectorAll(
      '[data-gallery-modal-close]'
    )
  );

  this.galleryModalPreviousButton =
    this.galleryModal.querySelector(
      '[data-gallery-modal-previous]'
    );

  this.galleryModalNextButton =
    this.galleryModal.querySelector(
      '[data-gallery-modal-next]'
    );

  this.galleryModalActiveIndex = 0;
  this.galleryModalPreviousFocus = null;
  this.galleryModalIsOpen = false;

  this.bindGalleryModalOpen();
  this.bindGalleryModalClose();
  this.bindGalleryModalNavigation();
  this.bindGalleryModalKeyboard();
  this.bindGalleryModalSwipe();
}

bindGalleryModalOpen() {
  this.galleryZoomTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const mediaItem = trigger.closest(
        '[data-gallery-media]'
      );

      if (!mediaItem) {
        return;
      }

      const mediaId = String(
        mediaItem.dataset.mediaId || ''
      );

      this.openGalleryModal(mediaId, trigger);
    });
  });
}

openGalleryModal(mediaId, trigger = null) {
  if (
    !this.galleryModal ||
    this.galleryModalItems.length === 0
  ) {
    return;
  }

  const matchingItem = this.galleryModalItems.find(
    (item) =>
      String(item.dataset.mediaId || '') === String(mediaId)
  );

  if (!matchingItem) {
    return;
  }

  this.galleryModalPreviousFocus =
    trigger || document.activeElement;

  this.galleryModal.hidden = false;
  this.galleryModalIsOpen = true;

  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';

  this.showGalleryModalItem(mediaId);

  window.requestAnimationFrame(() => {
    this.galleryModal.classList.add('is-open');

    const closeButton =
      this.galleryModal.querySelector(
        '[data-gallery-modal-close]'
      );

    if (closeButton) {
      closeButton.focus();
    }
  });
}

showGalleryModalItem(mediaId) {
  const selectedIndex = this.galleryModalItems.findIndex(
    (item) =>
      String(item.dataset.mediaId || '') === String(mediaId)
  );

  if (selectedIndex < 0) {
    return;
  }

  this.galleryModalItems.forEach((item, index) => {
    const isSelected = index === selectedIndex;

    item.classList.toggle('is-active', isSelected);
    item.hidden = !isSelected;

    item.setAttribute(
      'aria-hidden',
      isSelected ? 'false' : 'true'
    );
  });

  this.galleryModalActiveIndex = selectedIndex;

  this.updateGalleryModalNavigationState();
}

bindGalleryModalClose() {
  this.galleryModalCloseButtons.forEach((button) => {
    button.addEventListener('click', () => {
      this.closeGalleryModal();
    });
  });
}

closeGalleryModal() {
  if (
    !this.galleryModal ||
    !this.galleryModalIsOpen
  ) {
    return;
  }

  this.galleryModal.classList.remove('is-open');
  this.galleryModalIsOpen = false;

  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';

  window.setTimeout(() => {
    if (!this.galleryModal) {
      return;
    }

    this.galleryModal.hidden = true;

    if (
      this.galleryModalPreviousFocus &&
      typeof this.galleryModalPreviousFocus.focus === 'function'
    ) {
      this.galleryModalPreviousFocus.focus();
    }

    this.galleryModalPreviousFocus = null;
  }, 180);
}

bindGalleryModalNavigation() {
  if (this.galleryModalPreviousButton) {
    this.galleryModalPreviousButton.addEventListener(
      'click',
      () => {
        this.showPreviousGalleryModalItem();
      }
    );
  }

  if (this.galleryModalNextButton) {
    this.galleryModalNextButton.addEventListener(
      'click',
      () => {
        this.showNextGalleryModalItem();
      }
    );
  }
}

showPreviousGalleryModalItem() {
  if (this.galleryModalItems.length <= 1) {
    return;
  }

  let nextIndex = this.galleryModalActiveIndex - 1;

  if (nextIndex < 0) {
    nextIndex = this.galleryModalItems.length - 1;
  }

  const nextItem = this.galleryModalItems[nextIndex];

  if (!nextItem) {
    return;
  }

  this.showGalleryModalItem(
    String(nextItem.dataset.mediaId || '')
  );
}

showNextGalleryModalItem() {
  if (this.galleryModalItems.length <= 1) {
    return;
  }

  let nextIndex = this.galleryModalActiveIndex + 1;

  if (nextIndex >= this.galleryModalItems.length) {
    nextIndex = 0;
  }

  const nextItem = this.galleryModalItems[nextIndex];

  if (!nextItem) {
    return;
  }

  this.showGalleryModalItem(
    String(nextItem.dataset.mediaId || '')
  );
}

updateGalleryModalNavigationState() {
  const hasMultipleItems =
    this.galleryModalItems.length > 1;

  if (this.galleryModalPreviousButton) {
    this.galleryModalPreviousButton.disabled =
      !hasMultipleItems;

    this.galleryModalPreviousButton.setAttribute(
      'aria-disabled',
      hasMultipleItems ? 'false' : 'true'
    );
  }

  if (this.galleryModalNextButton) {
    this.galleryModalNextButton.disabled =
      !hasMultipleItems;

    this.galleryModalNextButton.setAttribute(
      'aria-disabled',
      hasMultipleItems ? 'false' : 'true'
    );
  }
}

bindGalleryModalKeyboard() {
  document.addEventListener('keydown', (event) => {
    if (!this.galleryModalIsOpen) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeGalleryModal();
      return;
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.showPreviousGalleryModalItem();
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.showNextGalleryModalItem();
      return;
    }

    if (event.key === 'Tab') {
      this.trapGalleryModalFocus(event);
    }
  });
}

trapGalleryModalFocus(event) {
  if (!this.galleryModal) {
    return;
  }

  const focusableElements = Array.from(
    this.galleryModal.querySelectorAll(
      [
        'button:not([disabled])',
        'a[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
      ].join(',')
    )
  ).filter((element) => {
    return (
      element.offsetWidth > 0 ||
      element.offsetHeight > 0 ||
      element === document.activeElement
    );
  });

  if (focusableElements.length === 0) {
    return;
  }

  const firstElement = focusableElements[0];
  const lastElement =
    focusableElements[focusableElements.length - 1];

  if (
    event.shiftKey &&
    document.activeElement === firstElement
  ) {
    event.preventDefault();
    lastElement.focus();
    return;
  }

  if (
    !event.shiftKey &&
    document.activeElement === lastElement
  ) {
    event.preventDefault();
    firstElement.focus();
  }
}

bindGalleryModalSwipe() {
  if (!this.galleryModal) {
    return;
  }

  let modalTouchStartX = 0;
  let modalTouchStartY = 0;
  let modalTouchEndX = 0;
  let modalTouchEndY = 0;

  this.galleryModal.addEventListener(
    'touchstart',
    (event) => {
      const touch = event.changedTouches[0];

      if (!touch) {
        return;
      }

      modalTouchStartX = touch.screenX;
      modalTouchStartY = touch.screenY;
    },
    {
      passive: true
    }
  );

  this.galleryModal.addEventListener(
    'touchend',
    (event) => {
      const touch = event.changedTouches[0];

      if (!touch) {
        return;
      }

      modalTouchEndX = touch.screenX;
      modalTouchEndY = touch.screenY;

      const horizontalDistance =
        modalTouchStartX - modalTouchEndX;

      const verticalDistance =
        modalTouchStartY - modalTouchEndY;

      if (
        Math.abs(horizontalDistance) <
        this.minimumSwipeDistance
      ) {
        return;
      }

      if (
        Math.abs(verticalDistance) >
        Math.abs(horizontalDistance)
      ) {
        return;
      }

      if (horizontalDistance > 0) {
        this.showNextGalleryModalItem();
      } else {
        this.showPreviousGalleryModalItem();
      }
    },
    {
      passive: true
    }
  );
}

    /* =========================================================
       FUTURE PART 3 METHODS — VARIANTS
       ========================================================= */

    initVariants() {
  if (!this.info) {
    return;
  }

  this.variantJsonElement = this.info.querySelector(
    '[data-product-variants]'
  );

  this.variantIdInput = this.info.querySelector(
    '[data-variant-id-input]'
  );

  this.productOptionGroups = Array.from(
    this.info.querySelectorAll('[data-product-option]')
  );

  this.productOptionInputs = Array.from(
    this.info.querySelectorAll('[data-option-value]')
  );

  this.productPriceElement = this.info.querySelector(
    '[data-product-price]'
  );

  this.productComparePriceElement = this.info.querySelector(
    '[data-product-compare-price]'
  );

  this.productDiscountElement = this.info.querySelector(
    '[data-product-discount]'
  );

  this.addToCartButton = this.info.querySelector(
    '[data-add-to-cart]'
  );

  this.addToCartText = this.info.querySelector(
    '[data-add-to-cart-text]'
  );

  this.buyNowButton = this.info.querySelector(
    '[data-buy-now]'
  );

  this.productVariants = [];
  this.currentVariant = null;

  if (this.variantJsonElement) {
    try {
      this.productVariants = JSON.parse(
        this.variantJsonElement.textContent
      );
    } catch (error) {
      this.productVariants = [];
    }
  }

  if (!Array.isArray(this.productVariants)) {
    this.productVariants = [];
  }

  this.bindVariantOptions();
  this.setInitialVariant();
}

bindVariantOptions() {
  this.productOptionInputs.forEach((input) => {
    input.addEventListener('change', () => {
      this.updateSelectedOptionStyles();
      this.updateSelectedOptionLabels();

      const selectedOptions =
        this.getSelectedOptionValues();

      const matchingVariant =
        this.findVariantByOptions(selectedOptions);

      this.setCurrentVariant(matchingVariant, {
        updateUrl: true,
        updateMedia: true
      });
    });
  });
}

setInitialVariant() {
  if (this.productVariants.length === 0) {
    return;
  }

  const currentVariantId = this.variantIdInput
    ? Number(this.variantIdInput.value)
    : null;

  let initialVariant = null;

  if (currentVariantId) {
    initialVariant = this.productVariants.find(
      (variant) => Number(variant.id) === currentVariantId
    );
  }

  if (!initialVariant) {
    const selectedOptions = this.getSelectedOptionValues();

    initialVariant = this.findVariantByOptions(
      selectedOptions
    );
  }

  if (!initialVariant) {
    initialVariant =
      this.productVariants.find(
        (variant) => variant.available
      ) || this.productVariants[0];
  }

  this.setVariantInputsFromVariant(initialVariant);

  this.setCurrentVariant(initialVariant, {
    updateUrl: false,
    updateMedia: true
  });

  this.updateSelectedOptionStyles();
  this.updateSelectedOptionLabels();
}

getSelectedOptionValues() {
  return this.productOptionGroups
    .sort((firstGroup, secondGroup) => {
      return (
        Number(firstGroup.dataset.optionPosition || 0) -
        Number(secondGroup.dataset.optionPosition || 0)
      );
    })
    .map((group) => {
      const checkedInput = group.querySelector(
        '[data-option-value]:checked'
      );

      return checkedInput
        ? checkedInput.value
        : '';
    });
}

findVariantByOptions(selectedOptions) {
  if (
    !Array.isArray(selectedOptions) ||
    selectedOptions.length === 0
  ) {
    return this.productVariants[0] || null;
  }

  return (
    this.productVariants.find((variant) => {
      if (!Array.isArray(variant.options)) {
        return false;
      }

      return variant.options.every(
        (optionValue, optionIndex) => {
          return (
            String(optionValue) ===
            String(selectedOptions[optionIndex])
          );
        }
      );
    }) || null
  );
}

setVariantInputsFromVariant(variant) {
  if (!variant || !Array.isArray(variant.options)) {
    return;
  }

  this.productOptionGroups.forEach(
    (group, groupIndex) => {
      const variantOptionValue =
        variant.options[groupIndex];

      if (variantOptionValue === undefined) {
        return;
      }

      const matchingInput = Array.from(
        group.querySelectorAll('[data-option-value]')
      ).find((input) => {
        return (
          String(input.value) ===
          String(variantOptionValue)
        );
      });

      if (matchingInput) {
        matchingInput.checked = true;
      }
    }
  );
}

setCurrentVariant(variant, options = {}) {
  const settings = {
    updateUrl: true,
    updateMedia: true,
    ...options
  };

  this.currentVariant = variant || null;

  if (!variant) {
    this.updateUnavailableVariantState();
    return;
  }

  if (this.variantIdInput) {
    this.variantIdInput.value = variant.id;
  }

  this.updateVariantPrice(variant);
  this.updateVariantAvailability(variant);
  this.updateOptionAvailability();
  this.updateSelectedOptionStyles();
  this.updateSelectedOptionLabels();

  if (settings.updateMedia) {
    this.updateVariantMedia(variant);
  }

  if (settings.updateUrl) {
    this.updateVariantUrl(variant);
  }

  this.section.dispatchEvent(
    new CustomEvent('custom-product:variant-change', {
      bubbles: true,
      detail: {
        variant
      }
    })
  );
}

updateVariantPrice(variant) {
  if (!variant) {
    return;
  }

  if (this.productPriceElement) {
    this.productPriceElement.textContent =
      this.formatMoney(variant.price);
  }

  const comparePrice =
    Number(variant.compare_at_price || 0);

  const currentPrice =
    Number(variant.price || 0);

  const isOnSale =
    comparePrice > currentPrice;

  if (this.productComparePriceElement) {
    if (isOnSale) {
      this.productComparePriceElement.textContent =
        this.formatMoney(comparePrice);

      this.productComparePriceElement.classList.remove(
        'is-hidden'
      );
    } else {
      this.productComparePriceElement.textContent = '';

      this.productComparePriceElement.classList.add(
        'is-hidden'
      );
    }
  }

  if (this.productDiscountElement) {
    if (isOnSale) {
      const discountPercentage = Math.round(
        ((comparePrice - currentPrice) * 100) /
        comparePrice
      );

      this.productDiscountElement.textContent =
        `${discountPercentage}% OFF`;

      this.productDiscountElement.classList.remove(
        'is-hidden'
      );
    } else {
      this.productDiscountElement.textContent = '';

      this.productDiscountElement.classList.add(
        'is-hidden'
      );
    }
  }
}

formatMoney(priceInCents) {
  const amount =
    Number(priceInCents || 0) / 100;

  if (
    window.Shopify &&
    typeof window.Shopify.formatMoney === 'function'
  ) {
    try {
      return window.Shopify.formatMoney(
        Number(priceInCents || 0)
      );
    } catch (error) {
      // Intl formatting will be used below.
    }
  }

  const currency =
    window.Shopify?.currency?.active ||
    document.documentElement.dataset.currency ||
    'INR';

  try {
    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-IN',
      {
        style: 'currency',
        currency,
        maximumFractionDigits: 2
      }
    ).format(amount);
  } catch (error) {
    return `₹${amount.toFixed(2)}`;
  }
}

updateVariantAvailability(variant) {
  const isAvailable =
    Boolean(variant && variant.available);

  if (this.addToCartButton) {
    this.addToCartButton.disabled = !isAvailable;
  }

  if (this.buyNowButton) {
    this.buyNowButton.disabled = !isAvailable;
  }

  if (this.addToCartText) {
    this.addToCartText.textContent = isAvailable
      ? 'Add to Cart'
      : 'Sold Out';
  }

  if (this.info) {
    this.info.classList.toggle(
      'is-variant-unavailable',
      !isAvailable
    );
  }
}

updateUnavailableVariantState() {
  if (this.variantIdInput) {
    this.variantIdInput.value = '';
  }

  if (this.addToCartButton) {
    this.addToCartButton.disabled = true;
  }

  if (this.buyNowButton) {
    this.buyNowButton.disabled = true;
  }

  if (this.addToCartText) {
    this.addToCartText.textContent =
      'Unavailable';
  }

  if (this.info) {
    this.info.classList.add(
      'is-variant-unavailable'
    );
  }
}

updateSelectedOptionStyles() {
  this.productOptionInputs.forEach((input) => {
    const label = input.closest(
      '[data-option-value-label]'
    );

    if (!label) {
      return;
    }

    label.classList.toggle(
      'is-selected',
      input.checked
    );
  });
}

updateSelectedOptionLabels() {
  this.productOptionGroups.forEach((group) => {
    const selectedInput = group.querySelector(
      '[data-option-value]:checked'
    );

    const selectedLabel = group.querySelector(
      '[data-selected-option-value]'
    );

    if (selectedLabel) {
      selectedLabel.textContent =
        selectedInput?.value || '';
    }
  });
}

updateVariantMedia(variant) {
  if (!variant) {
    return;
  }

  let featuredMediaId = null;

  if (
    variant.featured_media &&
    variant.featured_media.id
  ) {
    featuredMediaId = variant.featured_media.id;
  } else if (
    variant.featured_image &&
    variant.featured_image.id
  ) {
    featuredMediaId = variant.featured_image.id;
  }

  if (featuredMediaId) {
    this.showVariantMedia(featuredMediaId);
  }
}

updateVariantUrl(variant) {
  if (
    !variant ||
    !window.history ||
    typeof window.history.replaceState !== 'function'
  ) {
    return;
  }

  const productUrl =
    this.section.dataset.productUrl ||
    window.location.pathname;

  const url = new URL(
    productUrl,
    window.location.origin
  );

  url.searchParams.set(
    'variant',
    String(variant.id)
  );

  window.history.replaceState(
    {
      variantId: variant.id
    },
    '',
    `${url.pathname}${url.search}${url.hash}`
  );
}

updateOptionAvailability() {
  if (
    this.productOptionGroups.length === 0 ||
    this.productVariants.length === 0
  ) {
    return;
  }

  const selectedOptions =
    this.getSelectedOptionValues();

  this.productOptionGroups.forEach(
    (group, groupIndex) => {
      const optionInputs = Array.from(
        group.querySelectorAll('[data-option-value]')
      );

      optionInputs.forEach((input) => {
        const testOptions = [...selectedOptions];

        testOptions[groupIndex] = input.value;

        const matchingVariant =
          this.findVariantByOptions(testOptions);

        const optionAvailable = Boolean(
          matchingVariant &&
          matchingVariant.available
        );

        input.disabled = !matchingVariant;

        const label = input.closest(
          '[data-option-value-label]'
        );

        if (label) {
          label.classList.toggle(
            'is-unavailable',
            !optionAvailable
          );

          label.classList.toggle(
            'does-not-exist',
            !matchingVariant
          );
        }
      });
    }
  );
}

    /* =========================================================
       FUTURE PART 4 METHODS — CART
       ========================================================= */

   initProductForm() {
  if (!this.info) {
    return;
  }

  this.productForm = this.info.querySelector(
    '[data-product-form]'
  );

  this.addToCartButton = this.info.querySelector(
    '[data-add-to-cart]'
  );

  this.addToCartText = this.info.querySelector(
    '[data-add-to-cart-text]'
  );

  this.buyNowButton = this.info.querySelector(
    '[data-buy-now]'
  );

  this.formMessage = this.info.querySelector(
    '[data-product-form-message]'
  );

  this.quantityInput = this.info.querySelector(
    '[data-quantity-input]'
  );

  this.cartRequestInProgress = false;

  if (this.productForm) {
    this.productForm.addEventListener(
      'submit',
      (event) => {
        event.preventDefault();
        this.handleAddToCart();
      }
    );
  }

  if (this.buyNowButton) {
    this.buyNowButton.addEventListener(
      'click',
      () => {
        this.handleBuyNow();
      }
    );
  }
}

async handleAddToCart() {
  if (
    !this.productForm ||
    this.cartRequestInProgress
  ) {
    return;
  }

  const variantId = this.variantIdInput?.value;

  if (!variantId) {
    this.showFormMessage(
      'Please select an available product option.',
      'error'
    );
    return;
  }

  const quantity = this.getSelectedQuantity();

  this.cartRequestInProgress = true;
  this.setAddToCartLoading(true);
  this.showFormMessage('', '');

  try {
    const response = await fetch(
      this.getCartAddUrl(),
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity
            }
          ]
        })
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        'Unable to add this product to the cart.'
      );
    }

    this.showFormMessage(
      'Product added to cart.',
      'success'
    );

    this.updateCartCount(quantity);
    this.dispatchCartUpdate(result);

    await this.refreshThemeCartDrawer();

    this.openThemeCartDrawer();
  } catch (error) {
    this.showFormMessage(
      error?.message ||
      'Something went wrong. Please try again.',
      'error'
    );
  } finally {
    this.cartRequestInProgress = false;
    this.setAddToCartLoading(false);
  }
}

async handleBuyNow() {
  if (
    !this.buyNowButton ||
    this.cartRequestInProgress
  ) {
    return;
  }

  const variantId = this.variantIdInput?.value;

  if (!variantId) {
    this.showFormMessage(
      'Please select an available product option.',
      'error'
    );
    return;
  }

  const quantity = this.getSelectedQuantity();

  this.cartRequestInProgress = true;
  this.setBuyNowLoading(true);
  this.showFormMessage('', '');

  try {
    const response = await fetch(
      this.getCartAddUrl(),
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity
            }
          ]
        })
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        'Unable to continue to checkout.'
      );
    }

    window.location.href = this.getCheckoutUrl();
  } catch (error) {
    this.showFormMessage(
      error?.message ||
      'Something went wrong. Please try again.',
      'error'
    );

    this.cartRequestInProgress = false;
    this.setBuyNowLoading(false);
  }
}

getSelectedQuantity() {
  const value = Number(
    this.quantityInput?.value || 1
  );

  if (
    !Number.isFinite(value) ||
    value < 1
  ) {
    return 1;
  }

  return Math.floor(value);
}

getCartAddUrl() {
  if (
    window.routes &&
    window.routes.cart_add_url
  ) {
    return window.routes.cart_add_url;
  }

  if (
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
  ) {
    return `${window.Shopify.routes.root}cart/add.js`;
  }

  return '/cart/add.js';
}

getCartUrl() {
  if (
    window.routes &&
    window.routes.cart_url
  ) {
    return window.routes.cart_url;
  }

  if (
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
  ) {
    return `${window.Shopify.routes.root}cart`;
  }

  return '/cart';
}

getCheckoutUrl() {
  if (
    window.routes &&
    window.routes.cart_url
  ) {
    return `${window.routes.cart_url}/checkout`;
  }

  if (
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
  ) {
    return `${window.Shopify.routes.root}checkout`;
  }

  return '/checkout';
}

setAddToCartLoading(isLoading) {
  if (!this.addToCartButton) {
    return;
  }

  this.addToCartButton.classList.toggle(
    'is-loading',
    isLoading
  );

  this.addToCartButton.setAttribute(
    'aria-busy',
    isLoading ? 'true' : 'false'
  );

  this.addToCartButton.disabled =
    isLoading ||
    !this.currentVariant ||
    !this.currentVariant.available;

  if (this.addToCartText) {
    this.addToCartText.textContent = isLoading
      ? 'Adding...'
      : this.currentVariant?.available
        ? 'Add to Cart'
        : 'Sold Out';
  }
}

setBuyNowLoading(isLoading) {
  if (!this.buyNowButton) {
    return;
  }

  this.buyNowButton.classList.toggle(
    'is-loading',
    isLoading
  );

  this.buyNowButton.setAttribute(
    'aria-busy',
    isLoading ? 'true' : 'false'
  );

  this.buyNowButton.disabled =
    isLoading ||
    !this.currentVariant ||
    !this.currentVariant.available;

  this.buyNowButton.textContent = isLoading
    ? 'Processing...'
    : 'Get It Now';
}

showFormMessage(message, type = '') {
  if (!this.formMessage) {
    return;
  }

  this.formMessage.textContent = message || '';

  this.formMessage.classList.remove(
    'is-success',
    'is-error'
  );

  if (type === 'success') {
    this.formMessage.classList.add(
      'is-success'
    );
  }

  if (type === 'error') {
    this.formMessage.classList.add(
      'is-error'
    );
  }
}

updateCartCount(quantityAdded = 1) {
  const selectors = [
    '[data-cart-count]',
    '.cart-count-bubble span[aria-hidden="true"]',
    '.cart-count-bubble',
    '.header__cart-count',
    '.cart-count',
    '[data-header-cart-count]'
  ];

  const elements = document.querySelectorAll(
    selectors.join(',')
  );

  elements.forEach((element) => {
    const currentValue = Number(
      element.textContent.trim()
    );

    const newValue = Number.isFinite(currentValue)
      ? currentValue + quantityAdded
      : quantityAdded;

    element.textContent = String(newValue);
    element.hidden = false;
  });
}

dispatchCartUpdate(cartResponse) {
  document.dispatchEvent(
    new CustomEvent('cart:updated', {
      bubbles: true,
      detail: {
        source: 'custom-product-page',
        response: cartResponse
      }
    })
  );

  document.dispatchEvent(
    new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        source: 'custom-product-page'
      }
    })
  );

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      bubbles: true,
      detail: {
        source: 'custom-product-page',
        response: cartResponse
      }
    })
  );
}

async refreshThemeCartDrawer() {
  const sectionIds = this.getCartDrawerSectionIds();

  if (sectionIds.length === 0) {
    return;
  }

  const sectionsUrl = new URL(
    window.location.href
  );

  sectionsUrl.searchParams.set(
    'sections',
    sectionIds.join(',')
  );

  try {
    const response = await fetch(
      sectionsUrl.toString(),
      {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }
    );

    if (!response.ok) {
      return;
    }

    const sections = await response.json();

    this.replaceCartSections(sections);
  } catch (error) {
    // Theme cart refresh is optional.
  }
}

getCartDrawerSectionIds() {
  const ids = new Set();

  const candidates = document.querySelectorAll(
    [
      '[data-section-id][data-cart-drawer]',
      'cart-drawer[data-section-id]',
      '#CartDrawer[data-section-id]',
      '[id^="shopify-section-cart-drawer"]',
      '[id^="shopify-section-header"]'
    ].join(',')
  );

  candidates.forEach((element) => {
    const directId =
      element.dataset.sectionId;

    if (directId) {
      ids.add(directId);
    }

    const shopifySection =
      element.closest('[id^="shopify-section-"]') ||
      element.matches?.('[id^="shopify-section-"]')
        ? element
        : null;

    const sectionElement =
      shopifySection ||
      element.closest?.(
        '[id^="shopify-section-"]'
      );

    if (
      sectionElement &&
      sectionElement.id
    ) {
      ids.add(
        sectionElement.id.replace(
          'shopify-section-',
          ''
        )
      );
    }
  });

  return Array.from(ids);
}

replaceCartSections(sections) {
  if (
    !sections ||
    typeof sections !== 'object'
  ) {
    return;
  }

  Object.entries(sections).forEach(
    ([sectionId, html]) => {
      if (!html) {
        return;
      }

      const currentSection =
        document.getElementById(
          `shopify-section-${sectionId}`
        );

      if (!currentSection) {
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.innerHTML = html.trim();

      const newSection =
        wrapper.querySelector(
          `#shopify-section-${sectionId}`
        ) || wrapper.firstElementChild;

      if (!newSection) {
        return;
      }

      currentSection.replaceWith(newSection);
    }
  );
}

openThemeCartDrawer() {
  const cartDrawer =
    document.querySelector('cart-drawer') ||
    document.querySelector('[data-cart-drawer]') ||
    document.getElementById('CartDrawer') ||
    document.querySelector('.cart-drawer');

  if (cartDrawer) {
    if (
      typeof cartDrawer.open === 'function'
    ) {
      cartDrawer.open();
      return;
    }

    cartDrawer.classList.add(
      'is-open',
      'active',
      'animate'
    );

    cartDrawer.setAttribute(
      'open',
      ''
    );

    cartDrawer.setAttribute(
      'aria-hidden',
      'false'
    );

    document.documentElement.classList.add(
      'overflow-hidden'
    );

    document.body.classList.add(
      'overflow-hidden'
    );

    return;
  }

  const cartTrigger =
    document.querySelector(
      '[data-cart-drawer-open]'
    ) ||
    document.querySelector(
      '[aria-controls="CartDrawer"]'
    ) ||
    document.querySelector(
      'a[href="/cart"]'
    );

  if (cartTrigger) {
    cartTrigger.click();
    return;
  }

  window.location.href = this.getCartUrl();
}

    /* =========================================================
       FUTURE PART 5 METHODS — UI
       ========================================================= */

    initQuantity() {
  if (!this.info) {
    return;
  }

  this.quantityMinusButton = this.info.querySelector(
    '[data-quantity-minus]'
  );

  this.quantityPlusButton = this.info.querySelector(
    '[data-quantity-plus]'
  );

  this.quantityInput = this.info.querySelector(
    '[data-quantity-input]'
  );

  if (!this.quantityInput) {
    return;
  }

  this.quantityMinimum = Number(
    this.quantityInput.min || 1
  );

  this.quantityMaximum = this.quantityInput.max
    ? Number(this.quantityInput.max)
    : null;

  this.quantityStep = Number(
    this.quantityInput.step || 1
  );

  if (this.quantityMinusButton) {
    this.quantityMinusButton.addEventListener(
      'click',
      () => {
        this.changeQuantity(-this.quantityStep);
      }
    );
  }

  if (this.quantityPlusButton) {
    this.quantityPlusButton.addEventListener(
      'click',
      () => {
        this.changeQuantity(this.quantityStep);
      }
    );
  }

  this.quantityInput.addEventListener(
    'change',
    () => {
      this.normalizeQuantity();
    }
  );

  this.quantityInput.addEventListener(
    'blur',
    () => {
      this.normalizeQuantity();
    }
  );

  this.quantityInput.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.changeQuantity(this.quantityStep);
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.changeQuantity(-this.quantityStep);
      }
    }
  );

  this.normalizeQuantity();
}

changeQuantity(changeAmount) {
  if (!this.quantityInput) {
    return;
  }

  const currentValue = Number(
    this.quantityInput.value || this.quantityMinimum
  );

  let nextValue = currentValue + changeAmount;

  nextValue = Math.max(
    this.quantityMinimum,
    nextValue
  );

  if (
    this.quantityMaximum !== null &&
    Number.isFinite(this.quantityMaximum)
  ) {
    nextValue = Math.min(
      this.quantityMaximum,
      nextValue
    );
  }

  this.quantityInput.value = String(nextValue);

  this.quantityInput.dispatchEvent(
    new Event('change', {
      bubbles: true
    })
  );
}

normalizeQuantity() {
  if (!this.quantityInput) {
    return;
  }

  let value = Number(
    this.quantityInput.value
  );

  if (!Number.isFinite(value)) {
    value = this.quantityMinimum;
  }

  value = Math.max(
    this.quantityMinimum,
    value
  );

  if (
    this.quantityMaximum !== null &&
    Number.isFinite(this.quantityMaximum)
  ) {
    value = Math.min(
      this.quantityMaximum,
      value
    );
  }

  value = Math.floor(
    value / this.quantityStep
  ) * this.quantityStep;

  if (value < this.quantityMinimum) {
    value = this.quantityMinimum;
  }

  this.quantityInput.value = String(value);

  this.updateQuantityButtonState();
}

updateQuantityButtonState() {
  if (!this.quantityInput) {
    return;
  }

  const value = Number(
    this.quantityInput.value || this.quantityMinimum
  );

  if (this.quantityMinusButton) {
    this.quantityMinusButton.disabled =
      value <= this.quantityMinimum;

    this.quantityMinusButton.setAttribute(
      'aria-disabled',
      value <= this.quantityMinimum
        ? 'true'
        : 'false'
    );
  }

  if (this.quantityPlusButton) {
    const reachedMaximum =
      this.quantityMaximum !== null &&
      value >= this.quantityMaximum;

    this.quantityPlusButton.disabled =
      reachedMaximum;

    this.quantityPlusButton.setAttribute(
      'aria-disabled',
      reachedMaximum
        ? 'true'
        : 'false'
    );
  }
}

    initWishlist() {
  this.productWishlistButton =
    this.section.querySelector(
      '[data-product-wishlist]'
    );

  this.relatedWishlistButtons = Array.from(
    this.section.querySelectorAll(
      '[data-related-wishlist]'
    )
  );

  const wishlist = this.getProductWishlist();

  if (this.productWishlistButton) {
    const handle =
      this.productWishlistButton.dataset.productHandle;

    this.updateWishlistButtonState(
      this.productWishlistButton,
      wishlist.includes(handle)
    );

    this.productWishlistButton.addEventListener(
      'click',
      () => {
        this.toggleProductWishlist(
          this.productWishlistButton,
          handle
        );
      }
    );
  }

  this.relatedWishlistButtons.forEach(
    (button) => {
      const handle =
        button.dataset.productHandle;

      this.updateWishlistButtonState(
        button,
        wishlist.includes(handle)
      );

      button.addEventListener(
        'click',
        () => {
          this.toggleProductWishlist(
            button,
            handle
          );
        }
      );
    }
  );
}

getProductWishlist() {
  try {
    const storedWishlist =
      window.localStorage.getItem(
        'custom-product-wishlist'
      );

    if (!storedWishlist) {
      return [];
    }

    const parsedWishlist =
      JSON.parse(storedWishlist);

    return Array.isArray(parsedWishlist)
      ? parsedWishlist
      : [];
  } catch (error) {
    return [];
  }
}

saveProductWishlist(wishlist) {
  try {
    window.localStorage.setItem(
      'custom-product-wishlist',
      JSON.stringify(wishlist)
    );
  } catch (error) {
    // Local storage may be blocked.
  }
}

toggleProductWishlist(button, handle) {
  if (!button || !handle) {
    return;
  }

  const wishlist =
    this.getProductWishlist();

  const existingIndex =
    wishlist.indexOf(handle);

  let isActive = false;

  if (existingIndex === -1) {
    wishlist.push(handle);
    isActive = true;
  } else {
    wishlist.splice(existingIndex, 1);
    isActive = false;
  }

  this.saveProductWishlist(wishlist);

  this.updateAllWishlistButtons(
    handle,
    isActive
  );

  document.dispatchEvent(
    new CustomEvent(
      'custom-product:wishlist-change',
      {
        bubbles: true,
        detail: {
          handle,
          active: isActive,
          wishlist
        }
      }
    )
  );
}

updateAllWishlistButtons(
  handle,
  isActive
) {
  const buttons = this.section.querySelectorAll(
    [
      `[data-product-wishlist][data-product-handle="${this.escapeAttributeValue(handle)}"]`,
      `[data-related-wishlist][data-product-handle="${this.escapeAttributeValue(handle)}"]`
    ].join(',')
  );

  buttons.forEach((button) => {
    this.updateWishlistButtonState(
      button,
      isActive
    );
  });
}

updateWishlistButtonState(
  button,
  isActive
) {
  if (!button) {
    return;
  }

  button.classList.toggle(
    'is-active',
    isActive
  );

  button.setAttribute(
    'aria-pressed',
    isActive ? 'true' : 'false'
  );

  const textElement =
    button.querySelector('span');

  if (
    textElement &&
    button.matches('[data-product-wishlist]')
  ) {
    textElement.textContent = isActive
      ? 'Added to Wish List'
      : 'Add to Wish List';
  }

  const productTitle =
    this.section.querySelector(
      '.custom-product-info__title'
    )?.textContent?.trim() || 'product';

  button.setAttribute(
    'aria-label',
    isActive
      ? `Remove ${productTitle} from wishlist`
      : `Add ${productTitle} to wishlist`
  );
}

escapeAttributeValue(value) {
  if (
    window.CSS &&
    typeof window.CSS.escape === 'function'
  ) {
    return window.CSS.escape(
      String(value)
    );
  }

  return String(value).replace(
    /["\\]/g,
    '\\$&'
  );
}

    initProductTabs() {
  this.productTabs = Array.from(
    this.section.querySelectorAll(
      '[data-product-tab]'
    )
  );

  this.productTabPanels = Array.from(
    this.section.querySelectorAll(
      '[data-product-panel]'
    )
  );

  if (
    this.productTabs.length === 0 ||
    this.productTabPanels.length === 0
  ) {
    return;
  }

  this.productTabs.forEach(
    (tab, tabIndex) => {
      tab.setAttribute(
        'role',
        'tab'
      );

      tab.setAttribute(
        'tabindex',
        tab.classList.contains('is-active')
          ? '0'
          : '-1'
      );

      tab.addEventListener(
        'click',
        () => {
          this.activateProductTab(
            tab.dataset.productTab,
            true
          );
        }
      );

      tab.addEventListener(
        'keydown',
        (event) => {
          this.handleProductTabKeyboard(
            event,
            tabIndex
          );
        }
      );
    }
  );

  this.productTabPanels.forEach(
    (panel) => {
      panel.setAttribute(
        'role',
        'tabpanel'
      );
    }
  );

  const initialTab =
    this.productTabs.find((tab) =>
      tab.classList.contains('is-active')
    ) || this.productTabs[0];

  if (initialTab) {
    this.activateProductTab(
      initialTab.dataset.productTab,
      false
    );
  }

  this.activateReviewTabFromHash();
}
activateProductTab(
  tabName,
  focusTab = false
) {
  if (!tabName) {
    return;
  }

  const selectedTab =
    this.productTabs.find(
      (tab) =>
        tab.dataset.productTab === tabName
    );

  const selectedPanel =
    this.productTabPanels.find(
      (panel) =>
        panel.dataset.productPanel === tabName
    );

  if (!selectedTab || !selectedPanel) {
    return;
  }

  this.productTabs.forEach((tab) => {
    const isSelected =
      tab === selectedTab;

    tab.classList.toggle(
      'is-active',
      isSelected
    );

    tab.setAttribute(
      'aria-selected',
      isSelected ? 'true' : 'false'
    );

    tab.setAttribute(
      'tabindex',
      isSelected ? '0' : '-1'
    );
  });

  this.productTabPanels.forEach(
    (panel) => {
      const isSelected =
        panel === selectedPanel;

      panel.classList.toggle(
        'is-active',
        isSelected
      );

      panel.hidden = !isSelected;

      panel.setAttribute(
        'aria-hidden',
        isSelected ? 'false' : 'true'
      );
    }
  );

  if (focusTab) {
    selectedTab.focus();
  }

  this.section.dispatchEvent(
    new CustomEvent(
      'custom-product:tab-change',
      {
        bubbles: true,
        detail: {
          tab: tabName
        }
      }
    )
  );
}

handleProductTabKeyboard(
  event,
  currentIndex
) {
  const totalTabs =
    this.productTabs.length;

  if (totalTabs === 0) {
    return;
  }

  let nextIndex = currentIndex;

  if (event.key === 'ArrowRight') {
    event.preventDefault();

    nextIndex =
      (currentIndex + 1) % totalTabs;
  } else if (event.key === 'ArrowLeft') {
    event.preventDefault();

    nextIndex =
      (currentIndex - 1 + totalTabs) %
      totalTabs;
  } else if (event.key === 'Home') {
    event.preventDefault();
    nextIndex = 0;
  } else if (event.key === 'End') {
    event.preventDefault();
    nextIndex = totalTabs - 1;
  } else {
    return;
  }

  const nextTab =
    this.productTabs[nextIndex];

  if (!nextTab) {
    return;
  }

  this.activateProductTab(
    nextTab.dataset.productTab,
    true
  );
}

activateReviewTabFromHash() {
  const reviewLinks =
    this.section.querySelectorAll(
      'a[href="#shopify-product-reviews"]'
    );

  reviewLinks.forEach((link) => {
    link.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        this.activateProductTab(
          'reviews',
          false
        );

        const reviewsPanel =
          this.section.querySelector(
            '[data-product-panel="reviews"]'
          );

        if (reviewsPanel) {
          window.setTimeout(() => {
            reviewsPanel.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }, 50);
        }
      }
    );
  });

  if (
    window.location.hash ===
    '#shopify-product-reviews'
  ) {
    this.activateProductTab(
      'reviews',
      false
    );
  }
}

    /* =========================================================
       FUTURE PART 6 METHODS — RELATED PRODUCTS
       ========================================================= */

    initRelatedProducts() {

  this.relatedSlider =
    this.section.querySelector(
      '[data-related-slider]'
    );

  if (!this.relatedSlider) {
    return;
  }


  this.relatedPrevButton =
    this.section.querySelector(
      '[data-related-prev]'
    );


  this.relatedNextButton =
    this.section.querySelector(
      '[data-related-next]'
    );


  this.relatedCards =
    Array.from(
      this.relatedSlider.children
    );


  this.relatedGap = 20;


  if(this.relatedPrevButton){

    this.relatedPrevButton.addEventListener(
      'click',
      ()=>{
        this.scrollRelatedProducts(
          'prev'
        );
      }
    );

  }


  if(this.relatedNextButton){

    this.relatedNextButton.addEventListener(
      'click',
      ()=>{
        this.scrollRelatedProducts(
          'next'
        );
      }
    );

  }


  this.updateRelatedButtons();


  this.relatedSlider.addEventListener(
    'scroll',
    ()=>{
      this.updateRelatedButtons();
    }
  );


  window.addEventListener(
    'resize',
    ()=>{
      this.updateRelatedButtons();
    }
  );

}

initStickyProductInfo(){

  this.productInfo =
    this.section.querySelector(
      '[data-product-info]'
    );


  if(
    !this.productInfo ||
    window.innerWidth < 990
  ){

    return;

  }


  this.handleStickyProduct();

  window.addEventListener(
    'scroll',
    ()=>{
      this.handleStickyProduct();
    }
  );

}

handleStickyProduct(){

  if(!this.productInfo){
    return;
  }


  const offset =
    window.scrollY;


  if(offset > 150){

    this.productInfo.classList.add(
      'is-sticky'
    );

  }else{

    this.productInfo.classList.remove(
      'is-sticky'
    );

  }

}
initThemeEditorEvents(){

  document.addEventListener(
    'shopify:section:load',
    (event)=>{

      if(
        event.target.contains(
          this.section
        )
      ){

        this.destroy();

        this.init();

      }

    }
  );


  document.addEventListener(
    'shopify:block:select',
    (event)=>{

      const block =
        event.target;


      const mediaId =
        block.dataset.mediaId;


      if(mediaId){

        this.showVariantMedia(
          mediaId
        );

      }

    }
  );

}
destroy(){

  if(this.relatedSlider){

    this.relatedSlider
      .replaceWith(
        this.relatedSlider.cloneNode(true)
      );

  }


  document.removeEventListener(
    'shopify:section:load',
    this.init
  );

}
scrollRelatedProducts(direction){

  if(!this.relatedSlider){
    return;
  }


  const amount =
    this.relatedSlider.clientWidth * 0.8;


  this.relatedSlider.scrollBy({

    left:
      direction === 'next'
      ? amount
      : -amount,

    behavior:'smooth'

  });

}
updateRelatedButtons(){

  if(!this.relatedSlider){
    return;
  }


  const maxScroll =
    this.relatedSlider.scrollWidth -
    this.relatedSlider.clientWidth;


  const currentScroll =
    this.relatedSlider.scrollLeft;


  if(this.relatedPrevButton){

    this.relatedPrevButton.disabled =
      currentScroll <= 5;

  }


  if(this.relatedNextButton){

    this.relatedNextButton.disabled =
      currentScroll >= maxScroll - 5;

  }

}

    /* =========================================================
       CLEANUP
       ========================================================= */

    destroy() {
      this.pauseInactiveGalleryMedia(null);

      if (this.section.customProductPageInstance === this) {
        delete this.section.customProductPageInstance;
      }
    }
  }

  /* =========================================================
     SECTION INITIALIZATION
     ========================================================= */

  function initializeCustomProductPages(root = document) {
    const sections = [];

    if (
      root.matches &&
      root.matches('[data-custom-product]')
    ) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      root
        .querySelectorAll('[data-custom-product]')
        .forEach((section) => {
          sections.push(section);
        });
    }

    sections.forEach((section) => {
      if (section.customProductPageInstance) {
        return;
      }

      section.customProductPageInstance =
        new CustomProductPage(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeCustomProductPages();
      }
    );
  } else {
    initializeCustomProductPages();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeCustomProductPages(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const section =
        event.target.matches?.('[data-custom-product]')
          ? event.target
          : event.target.querySelector?.(
              '[data-custom-product]'
            );

      if (
        section &&
        section.customProductPageInstance
      ) {
        section.customProductPageInstance.destroy();
      }
    }
  );
})();